import { render, staticRenderFns } from "./PublicLayout.vue?vue&type=template&id=d8a1abd2&scoped=true&"
import script from "./PublicLayout.vue?vue&type=script&lang=js&"
export * from "./PublicLayout.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8a1abd2",
  null
  
)

export default component.exports